import React from 'react'
import Header from '../components/Header'
import { Playlist } from '../components/Playlist'

export default function Playlistpage() {
  return (
    <>
    <Header/>
    <Playlist/>    
    </>

  )
}
